import { Directive, HostListener, Input } from '@angular/core';
import { MixpanelService } from 'taxtank-core/common';

@Directive({
  selector: '[appTrack]',
  standalone: false
})
export class TrackDirective {
  @Input('appTrack') event: string;
  @Input() appTrackProps: { [key: string]: any } = {};

  constructor(private mpService: MixpanelService) {}

  @HostListener('click')
  onClick(): void {
    this.mpService.track(this.event, this.appTrackProps);
  }
}
